import { Skeleton as Skeleton$1 } from '@walmart-web/livingdesign-components';
import * as React from 'react';
import { applyCommonProps } from '../../../utility/commonProps.js';

/**
 * Skeletons are low-fidelity shapes that mimic interface elements and signify content loading, improving perceived responsiveness during slow data loading.
 *
 * - {@link https://livingdesign.walmart.com/components/skeleton/ Guidelines}
 * - {@link https://livingdesign.walmart.com/components/skeleton/react/ React documentation}
 *
 * ### Content
 *
 *
 * Skeleton accepts 3 optional props height, variant and width.
 *
 * ```tsx
 * <Skeleton />
 * ```
 *
 
 *  #### Variants of Skeleton structure
 *
 *  1. Rectangle -
 *     Use this shape variant for blocky components like charts, images, etc.
 *  2. Rounded -
 *     Use this shape variant for text elements.
 *

 *
 *  Rounded variant with and height specified width
 *
 * ```tsx
 * <Skeleton
 *  height="20px"
 *  variant="rounded"
 *  width="100px"
 * />
 * ```
 *
 * */

var Skeleton = function Skeleton(props) {
  var _applyCommonProps = applyCommonProps(props, Skeleton),
    height = _applyCommonProps.height,
    variant = _applyCommonProps.variant,
    width = _applyCommonProps.width; // Remove applyCommonProps if it's not necessary
  return /*#__PURE__*/React.createElement(Skeleton$1, {
    height: height,
    variant: variant,
    width: width,
    "data-testid": "skeleton"
  });
};

export { Skeleton, Skeleton as default };
